import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

const OtpTimer = ({ duration = 600, onExpire, t }) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    if (timeLeft === 0) {
      onExpire?.();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onExpire]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      sx={{ mt: 1 }}
    >
      {t("OTP valid for")}: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </Typography>
  );
};

export default OtpTimer;
